export default function OrganisationMembersIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9231 2.95574H10.1837C10.0541 2.20532 9.66358 1.52479 9.08108 1.03426C8.49858 0.543723 7.76153 0.274719 7 0.274719C6.23847 0.274719 5.50142 0.543723 4.91892 1.03426C4.33642 1.52479 3.94593 2.20532 3.81635 2.95574H1.07692C0.791305 2.95574 0.517386 3.06921 0.315423 3.27117C0.113461 3.47313 0 3.74705 0 4.03267V12.6481C0 12.9337 0.113461 13.2076 0.315423 13.4096C0.517386 13.6115 0.791305 13.725 1.07692 13.725H12.9231C13.2087 13.725 13.4826 13.6115 13.6846 13.4096C13.8865 13.2076 14 12.9337 14 12.6481V4.03267C14 3.74705 13.8865 3.47313 13.6846 3.27117C13.4826 3.06921 13.2087 2.95574 12.9231 2.95574V2.95574ZM7 1.34036C7.47739 1.34127 7.94104 1.50027 8.31853 1.79251C8.69601 2.08476 8.96608 2.4938 9.08654 2.95574H4.91346C5.03392 2.4938 5.30399 2.08476 5.68148 1.79251C6.05896 1.50027 6.52261 1.34127 7 1.34036V1.34036Z"
        fill="#8694AB"
      />
    </svg>
  );
}
